<template>
  <div>
    <div
      v-if="status"
      class="indicator" :class="[indicatorClass]"
      @click="$emit('clicked')"
    >
      <span class="help">{{ statusText }}</span>
    </div>

    <div v-else
      class="no-status"
      @click="$emit('clicked')"
    >
      NEW<v-icon>mdi-menu-down</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeadStatusIndicator',
  props: {
    status: String,
  },
  computed: {
    indicatorClass () {
      if (this.status === 'Funded') return 'green'
      if (this.status === 'Lending In Progress') return 'blue primary'
      if (this.status === 'Prospecting') return 'blue secondary'
      if (this.status === 'Client was not responsive') return 'yellow'
      if (this.status === 'Client was not a good fit/lead') return 'yellow'
      if (this.status === 'Client used a different lender') return 'yellow'
      if (this.status === 'Did not contact') return 'red'

      return ''
    },

    statusText () {
      return {
        Funded: 'Funded',
        'Lending In Progress': 'Lending In Progress',
        Prospecting: 'Prospecting',
        'Client was not responsive': 'Not Responsive',
        'Client was not a good fit/lead': 'Not good fit',
        'Client used a different lender': 'Used different lender',
        'Did not contact': 'Did not contact',
      }[this.status] || ''
    },
  },
}
</script>

<style lang="scss" scoped>
div.indicator {
  padding: 2px 10px;
  border-radius: 4px;
  border: 2px solid transparent;
  text-align: center;

  cursor: pointer;

  white-space: nowrap;

  &.green {
    background-color: #D5FADD !important;
    border-color: #38BE56 !important;
  }

  &.blue.primary {
    background-color: #D8FAFD !important;
    border-color: #0096A6 !important;
  }

  &.blue.secondary {
    background-color: #D1EAF5 !important;
    border-color: #194253 !important;
  }

  &.yellow {
    background-color: #FAEDCA !important;
    border-color: #F3C036 !important;
  }

  &.red {
    background-color: #FFDEDE !important;
    border-color: #C32020 !important;
  }
}

div.no-status {
  padding: 0 5px;

  display: inline-block;
  cursor: pointer;

  border-bottom: 2px solid rgba($inputBorderColorFilled, 0.5);

  color: $inputBorderColorFilled;
  font-family: "Sansation Bold", sans-serif;
  font-size: 10px;

  .v-icon {
    color: $inputBorderColorFilled;
    font-size: 18px;
  }
}
</style>
